import React, { useEffect, useRef, useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import AuthLayout from "@/pages/AuthLayout";
import { Loading } from "@/components/shared";

export default function MagicVerify() {
  const [params] = useSearchParams();
  const { applyAuth } = useAuth();
  const nav = useNavigate();
  const [error, setError] = useState(null);
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const token = params.get("token");
    if (!token) { setError("No sign-in token provided."); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/magic-link/verify", { token });
        applyAuth(data);
        nav("/app");
      } catch (err) {
        setError(formatApiErrorDetail(err.response?.data?.detail));
      }
    })();
  }, [params, applyAuth, nav]);

  if (error) {
    return (
      <AuthLayout title="Sign-in link problem" subtitle={error}>
        <Link to="/login" className="inline-flex items-center justify-center w-full rounded-full bg-nm-coral px-6 py-3 text-sm font-medium text-white" data-testid="back-to-login">
          Request a new link
        </Link>
      </AuthLayout>
    );
  }
  return <div className="min-h-screen bg-nm-bg"><Loading label="Signing you in…" /></div>;
}
